<template>
  <company-form-blank
    submit-label="Сохранить"
    v-bind="$attrs"
    :errors="errors"
    @submit="processCompanyForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateCurrentCompany } from '@/services/company.service'
import companyFormBlank from '@/components/forms/company/CompanyFormBlank'

export default {
  name: 'company-edit-form',
  components: { companyFormBlank },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        company: {
          id: [],
          name: [],
          bill_template: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    updateCurrentCompany: updateCurrentCompany,

    processCompanyForm () {
      this._updateCompany().then((success) => {
        if (success) {
          this.showMsg('Информация о компании была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    _updateCompany () {
      return this.updateCurrentCompany(this.$attrs.company).then((response) => {
        this.fillErrors(this.errors.company, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.company, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (msg, type, title) {
      this.$parent.$parent.showPopupMsg(msg, type, title)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompanyEditForm.vue?2e22c570